import { get } from 'lodash-es'

const getInitialState = (isQuestionsEnabledDefault = false) => ({
  unreadQuestionsIdList: new Set(),
  isSecondaryPanelVisible: false,
  secondaryPanelContentType: null,
  isQuestionsEnabled: isQuestionsEnabledDefault,
  isShowingSpeakers: true,
})

export default ({ actionNames, isQuestionsEnabledDefault }) => {
  const initialState = getInitialState(isQuestionsEnabledDefault)

  return (state = initialState, action = undefined) => {
    switch (action.type) {
      case actionNames.INIT: {
        return {
          ...state,
          selectedSidebarTab: action.defaultSidebarTab,
        }
      }
      case actionNames.FETCH_LIVE_DATA_SUCCESS: {
        return {
          ...state,
          isQuestionsEnabled: get(action, 'liveData.question_mode') === 'ask',
        }
      }
      case actionNames.REALTIME_QUESTION_ADDED: {
        return {
          ...state,
          unreadQuestionsIdList: new Set([
            ...state.unreadQuestionsIdList,
            action.commentId,
          ]),
        }
      }
      case actionNames.REALTIME_QUESTION_REMOVED: {
        const { commentId } = action
        return {
          ...state,
          unreadQuestionsIdList: new Set(
            Array.from(state.unreadQuestionsIdList.values()).filter(
              (id) => id !== commentId
            )
          ),
        }
      }
      case actionNames.TOGGLE_SECONDARY_PANEL: {
        const contentType = action.payload[0] || null
        const { unreadQuestionsIdList, secondaryPanelContentType } = state
        const unreadQuestions =
          contentType === 'questions' ? new Set() : unreadQuestionsIdList

        // closing an already open sidebar with content type
        if (contentType === secondaryPanelContentType) {
          return {
            ...state,
            isSecondaryPanelVisible: false,
            secondaryPanelContentType: null,
            unreadQuestionsIdList: unreadQuestions,
          }
        }

        // opening a sidebar with the correct content type
        return {
          ...state,
          isSecondaryPanelVisible: true,
          secondaryPanelContentType: contentType,
          unreadQuestionsIdList: unreadQuestions,
        }
      }
      case actionNames.TOGGLE_QUESTIONS_MODE: {
        return {
          ...state,
          isQuestionsEnabled: !state.isQuestionsEnabled,
        }
      }
      /**
       * Since this is a sub feature that is dispatching this action, we have to
       *  hardcode it since we can't get to it otherwise.
       */
      case 'INFO-PANEL-SPEAKERS:FETCH_SUCCESS': {
        const { speakers } = action

        return {
          ...state,
          isShowingSpeakers: !!speakers?.length,
        }
      }
      default:
        return state
    }
  }
}
